import { CleanButton } from "@components/Buttons"
import { theme } from "@config/theme"
import styled from "styled-components"

export const Button = styled(CleanButton)`
  position: absolute;
  height: 100%;
  width: 3rem;
  display: flex;
  align-items: center;
  top: 0;
  color: ${theme.colors.purple};
  cursor: pointer;

  svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: currentColor;
  }

  &[data-variant="prev"] {
    justify-content: flex-start;
    left: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 35%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  &[data-variant="next"] {
    justify-content: flex-end;
    right: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 35%
    );
  }
`
